import { useTranslation } from "react-i18next";
import { Button } from "./Button";
import { Dialog } from "./Dialog";

export interface MessageListDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  messages: string[];
  description?: string;
}

/**
 * The import-report dialog: every import endpoint answers with a `string[]` of
 * per-row problems, and an empty list is the success case. Showing them as a
 * scrollable list beats a truncated toast for a 200-row spreadsheet.
 */
export function MessageListDialog({
  open,
  onClose,
  title,
  messages,
  description,
}: MessageListDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      {...(description ? { description } : {})}
      size="lg"
      actions={
        <Button variant="primary" onClick={onClose}>
          {t("dialog.confirm", "Confirm")}
        </Button>
      }
    >
      <ul className="flex flex-col gap-1">
        {messages.map((message, index) => (
          <li
            key={`${index}-${message}`}
            className="rounded bg-risk-soft px-2 py-1 text-[13px] text-risk"
          >
            {message}
          </li>
        ))}
      </ul>
    </Dialog>
  );
}
